import { Link } from "react-router-dom";
import Logo from "./Logo";

const cols = [
  { title: "Services", links: [["Content Creation Sydney", "/content-creation-sydney"], ["Social Media Marketing", "/social-media-marketing-sydney"], ["Meta Ads Agency", "/meta-ads-agency-sydney"], ["Website Design", "/website-design-sydney"], ["Custom Business Systems", "/custom-business-systems"]] },
  { title: "Industries", links: [["Food Marketing Agency", "/food-marketing-agency-australia"], ["Food Manufacturers", "/food-manufacturer-marketing"], ["Food Distributors", "/food-distributor-marketing"], ["Food Wholesalers", "/food-wholesaler-marketing"], ["Packaging Marketing", "/packaging-marketing-agency"], ["Food Equipment", "/food-equipment-marketing"], ["Manufacturers", "/manufacturing-marketing-agency"]] },
  { title: "Company", links: [["Our Work", "/work"], ["All services", "/services"], ["About", "/about"], ["Get in touch", "/enquire"]] },
];

const Footer = () => (
  <footer className="bg-[#2E1B16] text-[#FAF7F2] py-16 md:py-20" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-12">
        <div>
          <Link to="/"><Logo light /></Link>
          <p className="font-display text-2xl md:text-3xl text-[#FAF7F2]/50 max-w-md leading-snug mt-6">
            We find the story inside a business and <span className="font-accent text-[#38BDF8]">turn it into marketing.</span>
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <p className="label-eyebrow text-[#FAF7F2]/40 mb-5">{c.title}</p>
            <ul className="space-y-3">
              {c.links.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-[#FAF7F2]/70 hover:text-[#38BDF8] transition-colors" data-testid={`footer-link-${to}`}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4 text-sm text-[#FAF7F2]/40">
        <span>© {new Date().getFullYear()} Viral Vision Media. All rights reserved.</span>
        <div className="flex items-center gap-5">
          <Link to="/portal" data-testid="footer-client-login" className="inline-flex items-center gap-1.5 rounded-full border border-white/20 px-4 py-2 font-semibold text-[#FAF7F2]/80 hover:border-[#38BDF8] hover:text-[#38BDF8] transition-colors">
            Client Login →
          </Link>
          <a href="mailto:info@viralvisionmediaau.com" className="hover:text-[#38BDF8] transition-colors" data-testid="footer-email">info@viralvisionmediaau.com</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
